import type { AppState } from '@store/types'
import { select } from 'redux-saga/effects'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import type { Ga4State } from '../types'

// Цифры на экране — это отчёт ok и метрики хотя бы у одной страницы: при
// пустом pages на всех ушках только «no URL» / «no data».
export function* trackMetricsView() {
  const { status, pages }: Ga4State = yield select(
    (state: AppState) => state.ga4
  )

  if (status === 'ok' && Object.keys(pages).length > 0) {
    sendGtmEvent(GtmTriggerName.ANALYTICS_METRICS_VIEW)
  }
}
